<template>
	<div class="phonebox" @click='bgClick' id='phonebox'  @mouseover="selectSectionUp($event)">

		<div class="phoneBlock" >
			<div v-if="phoneData.news && phoneData.news.title" class="fixedPhone" @click='pageDClick("news")'>
				<div class="header" @click='headClick'>
					<div class="pagename" :style='`background:${appConfig.navigationBar ? appConfig.navigationBar.bgColor =="useSys" ? appConfig.style :  appConfig.navigationBar.bgColor =="useUser" ? appConfig.navigationBar.userBg:"" : "#ffffff"} `'>
						<div class="top">
							<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#ffffff"' src="@/assets/color/navigator_01.png" />
							<img v-else src="@/assets/color/navigator_02.png" />
						</div>
						<div class="title">
							<div class="left" @click='clearNews'>
								<svg-icon icon-class='left'/>
							</div>
							<div class="mid" :style='`color:${appConfig.navigationBar && appConfig.navigationBar.frontColor || "#000000"}`'>文章详情</div>
							<div class="right">
								<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#000000"' src="@/assets/color/close_2.png" alt="">
								<img v-else src="@/assets/color/close_1.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="newscontent">
					<div class="title">{{phoneData.news.title}}</div>
					<div class="date">{{phoneData.news.release_time}}</div>
					<div class="content" v-html='phoneData.news.content'></div>
				</div>
			</div>
			<div v-if="phoneData.sever && phoneData.sever.title" class="fixedPhone severDetail" @click='pageDClick("sever")'>
				<div class="header" @click='headClick'>
					<div class="pagename" :style='`background:${appConfig.navigationBar ? appConfig.navigationBar.bgColor =="useSys" ? appConfig.style :  appConfig.navigationBar.bgColor =="useUser" ? appConfig.navigationBar.userBg:"" : "#ffffff"} `'>
						<div class="top">
							<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#ffffff"' src="@/assets/color/navigator_01.png" />
							<img v-else src="@/assets/color/navigator_02.png" />
						</div>
						<div class="title">
							<div class="left" @click='clearNews'>
								<svg-icon icon-class='left'/>
							</div>
							<div class="mid" :style='`color:${appConfig.navigationBar && appConfig.navigationBar.frontColor || "#000000"}`'>服务详情</div>
							<div class="right">
								<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#000000"' src="@/assets/color/close_2.png" alt="">
								<img v-else src="@/assets/color/close_1.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="content">
					<div class="banner">
						<el-carousel arrow='never' trigger="click" height="200px">
							<el-carousel-item v-for='(swiper,swiperi) in phoneData.sever.cover_url' :key="swiperi" style='height: 200px'>
								<div class="img"  style="width: 100%;height: 200px;"><img style="width: 100%;" :src="swiper"></div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="info">
						<div class="title">
							<p>{{phoneData.sever.title}}</p>
							<svg-icon icon-class='share'/>
						</div>
						<div class="summary">
							{{phoneData.sever.summary}}
						</div>
						<div class="price" v-if='phoneData.sever.price_type==0'>
							<p :style="`color:${appConfig.style}`">￥{{phoneData.sever.sale_price || phoneData.sever.price}}</p>
							<p class="sale" v-if='phoneData.sever.sale_price' >￥{{phoneData.sever.price}}</p>
						</div>
						<div class="price" v-if='phoneData.sever.price_type==1'>
							<p :style="`color:${appConfig.style}`">免费</p>
						</div>
						<div class="price" v-if='phoneData.sever.price_type==2'>
							<p :style="`color:${appConfig.style}`">价格面议</p>
						</div>
					</div>
					<div class="d_title">
						服务详情
					</div>
					<div class="detail" v-html='phoneData.sever.details'></div>
				</div>

				<div class="service-footer">
					<div class="card-footer">
						<div class="left">
							<div class="btn" @click='openUrl("share://")' v-if='appConfig.severConfig.showShare'>
								<svg-icon class='ico' icon-class='share' />
								<p>分享</p>
							</div>
							<div class="btn" @click='openUrl("share://")' v-if='appConfig.severConfig.showPhone'>
								<svg-icon class='ico' icon-class='phone' />
								<p>电话</p>
							</div>
						</div>
						<div class="right"  @click='openUrl("share://")' :style="`background:${appConfig.style}`">{{appConfig.severConfig.btn}}</div>
					</div>
				</div>
			</div>
			<div v-if="phoneData.card && phoneData.card.name" class="fixedPhone"  @click='pageDClick("card")'>
				<div class="header" @click='headClick'>
					<div class="pagename" :style='`background:${appConfig.navigationBar ? appConfig.navigationBar.bgColor =="useSys" ? appConfig.style :  appConfig.navigationBar.bgColor =="useUser" ? appConfig.navigationBar.userBg:"" : "#ffffff"} `'>
						<div class="top">
							<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#ffffff"' src="@/assets/color/navigator_01.png" />
							<img v-else src="@/assets/color/navigator_02.png" />
						</div>
						<div class="title">
							<div class="left" @click='clearNews'>
								<svg-icon icon-class='left'/>
							</div>
							<div class="mid" :style='`color:${appConfig.navigationBar && appConfig.navigationBar.frontColor || "#000000"}`'>名片详情</div>
							<div class="right">
								<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#000000"' src="@/assets/color/close_2.png" alt="">
								<img v-else src="@/assets/color/close_1.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="cardbody">
					<div class="bgs" :style="`background:${appConfig.style}` "></div>
					<div class="card-intro">
						<div class="info">
							<div class="name">{{phoneData.card.name}} <span class="post">{{phoneData.card.post}}</span></div>
							<div class="telphone">联系电话:{{phoneData.card.telphone}}</div>
						</div>
						<div class="head">
							<img :src="phoneData.card.avatar" alt="">
						</div>
					</div>
					<div class="infoNav">
						<div class='li' @click='infoNav="联系我"' :class="infoNav=='联系我'?'on':''">联系我</div>
						<div class='li' @click='infoNav="关于我"' :class="infoNav=='关于我'?'on':''">关于我</div>
					</div>
					<div class="connect-content" v-if='infoNav=="联系我"'>
						<div class="section">
							<p>{{phoneData.card.telphone}}</p>
							<div class="ico">
								<svg-icon icon-class='phone' />
							</div>
						</div>
						<div class="section">
							<p>{{phoneData.card.email}}</p>
							<div class="ico">
								<svg-icon icon-class='mail' />
							</div>
						</div>
						<div class="section">
							<p>{{phoneData.card.address}}</p>
							<div class="ico">
								<svg-icon icon-class='address' />
							</div>
						</div>
						<div class="section">
							<p>{{phoneData.card.wechat}}</p>
							<div class="ico">
								<svg-icon icon-class='wechat' />
							</div>
						</div>
					</div>
					<div class="connect-content" v-if='infoNav=="关于我"' v-html='phoneData.card.introduction'></div>
				</div>
				<div class="service-footer">
					<div class="card-footer">
						<div class="left">
							<div class="btn" @click='openUrl("share://")'>
								<svg-icon class='ico' icon-class='share' />
								<p>分享</p>
							</div>
						</div>
						<div class="right"  @click='openUrl("share://")' :style="`background:${appConfig.style}`">保存到通讯录</div>
					</div>
				</div>
			</div>
			<div class="header" @click='headClick'>
				<div class="pagename" :style='`background:${appConfig.navigationBar ? appConfig.navigationBar.bgColor =="useSys" ? appConfig.style :  appConfig.navigationBar.bgColor =="useUser" ? appConfig.navigationBar.userBg:"" : "#ffffff"} `'>
					<div class="top">
						<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#ffffff"' src="@/assets/color/navigator_01.png" />
						<img v-else src="@/assets/color/navigator_02.png" />
					</div>
					<div class="title">
						<div class="left"></div>
						<div class="mid" :style='`color:${appConfig.navigationBar && appConfig.navigationBar.frontColor || "#000000"}`'>{{appConfig.appPage[appConfig.appPageon].title}}</div>
						<div class="right">
							<img v-if='appConfig.navigationBar && appConfig.navigationBar.frontColor == "#000000"' src="@/assets/color/close_2.png" alt="">
							<img v-else src="@/assets/color/close_1.png" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="body" id="body">
				<template v-if='phoneData.body[0] && phoneData.body[0].systemPage'>
					<div class="goodsClassify" @click='goodsclassifyClick(phoneData.body)' v-if='phoneData.body[0].page=="goodsClassify"'>
						<div class="topsearch">
							<div class="input" @click='openUrl("null://123")'>
								<div class="ico">
									<svg-icon icon-class='search' />
								</div>
								<input type="text" placeholder="请输入搜索关键字" disabled="disabled">
							</div>
						</div>
						<div class="classify classifyB" v-if='phoneData.body[0].styleon=="B"'>
							<div class="left">
								<div class="li" :class='ni==goodsClassnavon? "goodsClassnavon":""' @click='goodsClassnavon=ni' :style='ni==goodsClassnavon? "border-left:2px solid "+appConfig.style:""'  v-for='(nav,ni) in goodsClassifyStore' :key='ni' > <span v-if='nav.parent_id==0'>{{nav.title}}</span>
								</div>
							</div>
							<div class="rightB" v-if='goodsClassifyStore[goodsClassnavon]'>
								<div class="right_section">
									<div class="title">{{goodsClassifyStore[goodsClassnavon].title}}</div>
									<div class="ul">
										<div class="li"  @click='openUrl("classify://"+nav.parent_id+"-"+nav.id)' v-for='(nav,ni) in goodsClassifyStore[goodsClassnavon].children' :key='ni'>
											<p>{{nav.title}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="classify" v-else-if='phoneData.body[0].styleon=="C"'>
							<div class="left">
								<div class="li" :class='ni==goodsClassnavon? "goodsClassnavon":""' @click='goodsClassnavon=ni' :style='ni==goodsClassnavon? "border-left:2px solid "+appConfig.style:""' v-for='(nav,ni) in goodsClassifyStore' :key='ni' > <span v-if='nav.parent_id==0'>{{nav.title}}</span>
								</div>
							</div>
							<div class="right" v-if='goodsClassifyStore[goodsClassnavon]'>
								<div class="right_section">
									<div class="title">{{goodsClassifyStore[goodsClassnavon].title}}</div>
									<div class="ul">
										<div class="li"  @click='openUrl("classify://"+nav.parent_id+"-"+nav.id)' v-for='(nav,ni) in goodsClassifyStore[goodsClassnavon].children' :key='ni'>
											<div class="img"><img :src="nav.img_url" alt=""></div>
											<p>{{nav.title}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="classifyA" v-else>
							<div class="left">
								<div class="li" @click='goodsClassnavon=ni;goodsClassnavonChild=0'  v-for='(nav,ni) in goodsClassifyStore' :key='ni'  >
									<p  :class='ni==goodsClassnavon? "goodsClassnavon":""' :style='ni==goodsClassnavon? "color: "+appConfig.style:""'>{{nav.title}}</p>
									<div class="" @click.stop='goodsClassnavonChild=nci' :style="goodsClassnavonChild==nci? 'color: '+appConfig.style:'' "  v-for='(nc,nci) in goodsClassifyStore[goodsClassnavon].children' :key='nci'>
										<p v-if='ni==goodsClassnavon && nc.title != "根分类"'>{{nc.title}}</p>
									</div>
								</div>
							</div>
							<div class="right" v-if='goodsClassifyStore[goodsClassnavon]'>
								<div class="list" v-for='(sever,si) in ajaxData.goodsList' @click='openUrl("goods://"+sever.id)'>
									<div class="img"><img v-if='sever.images' :src="sever.images[0]"></div>
									<div class="info">
										<div class="infotop">
											<p class="title">{{sever.title}}</p>
											<p class="key">{{sever.introduction}}</p>
											<p class='date'>{{sever.date}}</p>
										</div>
										<div class="infobottom">
											<div class="price">￥{{sever.promotional_price>0 ? sever.promotional_price : sever.price}}
															<span class='price_line' v-if='sever.price>0'>{{sever.price}}</span>
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
					<div class="goodslist" v-if='phoneData.body[0].page=="goodslist"'>
						<div class="topsearch"  @click='openUrl("null://123")'>
							<div class="input">
								<div class="ico">
									<svg-icon icon-class='search' />
								</div>
								<input type="text" placeholder="请输入搜索关键字" disabled="disabled">
							</div>
							<svg-icon icon-class='liststyle' style='color: #888'/>
						</div>
						<div class="goodstopnav"  @click='openUrl("null://123")'>
							<div class="li lion">综合</div>
							<div class="li">销量</div>
							<div class="li">上新</div>
						</div>
						<div class="alist"  @mouseover="selectSection($event,'goodsList')">
							<div class="list resizingLi" v-for='(sever,si) in ajaxData.goodsList' v-if='ajaxData.goodsClassifyon==0' @click='openUrl("goods://"+sever.id)'>
								<div class="showProps">
									<div class="icoli" title='编辑商品' @click.stop='openEdit("商品",sever)'>
										<svg-icon class='icon' icon-class='edit1'/>
									</div>
									<div class="icoli" title='删除商品' @click.stop='openDel("商品",sever)' >
										<svg-icon class='icon' icon-class='del'/>
									</div>
								</div>
								<div class="img"><img v-if='sever.images' :src="sever.images[0]"></div>
								<div class="left">
									<p class="title">{{sever.title}}</p>
									<!-- <p class="key">{{sever.introduction}}</p> -->
									<div class="bottom">
										<div class="price">
											<p :style="'color:'+appConfig.style">￥{{ sever.promotional_price>0 ? sever.promotional_price:sever.price }}</p>
											<p v-if='sever.promotional_price>0' >￥{{sever.price}}</p>
										</div>
										<div class="car"  @click='openUrl("null://123")'>
											<svg-icon icon-class='cart' />
										</div>
									</div>
								</div>
							</div>
							<div class="list" v-for='(sever,si) in ajaxData.goodsList' v-if='ajaxData.goodsClassifyon==sever.classify_id' @click='openUrl("goods://"+sever.id)'>
								<div class="left">
									<p class="title">{{sever.title}}</p>
									<p class="key">{{sever.introduction}}</p>
									<p class='date'>{{sever.date}}</p>
								</div>
								<img v-if='sever.images' :src="sever.images[0]">
							</div>
						</div>
					</div>
					<div class="newslist" v-if='phoneData.body[0].page=="newslist"'>
						<div class="topnav parent-dom" >
							<vue-scroll :ops='vuescroll_ops' @mouseover.native="selectSection($event,'classifyInNav')" class='newListNav'>
								<div class="li child-dom" @click='ajaxData.articleClassifyon=0' :style='ajaxData.articleClassifyon == 0? "border-color:"+appConfig.style+";font-weight:bold;color:"+appConfig.style:"" ' >全部</div>
								<div class="li child-dom"  @click='ajaxData.articleClassifyon=list.id' :style='ajaxData.articleClassifyon == list.id? "border-color:"+appConfig.style+";font-weight:bold;color:"+appConfig.style:"" '  v-for='(list,li) in ajaxData.articleClassify'>{{list.title}}</div>
							</vue-scroll>
						</div>
						<div style='height: 50px'></div>
						<div class="alist"  @mouseover="selectSection($event,'atricleList')">
							<div class="list resizingLi" v-for='(sever,si) in ajaxData.articlelist' v-if='ajaxData.articleClassifyon==0' @click='openUrl("news://"+sever.id)'>
								<div class="showProps">
									<div class="icoli" title='编辑文章' @click.stop='openEdit("文章",sever)'>
										<svg-icon class='icon' icon-class='edit1'/>
									</div>
									<div class="icoli" title='删除文章' @click.stop='openDel("文章",sever)' >
										<svg-icon class='icon' icon-class='del'/>
									</div>
								</div>
								<div class="left">
									<p class="title">{{sever.label}}</p>
									<p class="key">{{sever.content |filterHtml}}</p>
									<p class='date'>{{sever.date}}</p>
								</div>
								<img v-if='sever.img' :src="sever.img[0]">
							</div>
							<div class="list" v-for='(sever,si) in ajaxData.articlelist' v-if='ajaxData.articleClassifyon==sever.classify_id' @click='openUrl("news://"+sever.id)'>
								<div class="left">
									<p class="title">{{sever.label}}</p>
									<p class="key">{{sever.content | filterHtml}}</p>
									<p class='date'>{{sever.date}}</p>
								</div>
								<img v-if='sever.img' :src="sever.img[0]">
							</div>
						</div>
					</div>
					<div class="cardlist" v-if='phoneData.body[0].page=="cardlist"'  @mouseover="selectSection($event,'cardList')" >
						<div class="list resizingLi" v-for='(card,cardi) in ajaxData.cardlist' @click='openUrl("card://"+card.id,card)'>
							<div class="showProps">
								<div class="icoli" title='编辑名片' @click.stop='openEdit("名片",card)'>
									<svg-icon class='icon' icon-class='edit1'/>
								</div>
								<div class="icoli" title='删除名片' @click.stop='openDel("名片",card)' >
									<svg-icon class='icon' icon-class='del'/>
								</div>
							</div>

							<div class="head">
								<img :src="card.avatar" alt="">
							</div>
							<div class="info">
								<p class="title">{{card.name}}</p>
								<p class="key">{{card.post}}</p>
							</div>
							<div class="phone" @click='openUrl("tel://"+card.telphone)'>
								<svg-icon icon-class='phone' />
							</div>
							<div class="icoright" >
								<svg-icon icon-class='right' />
							</div>
						</div>
					</div>
					<div class="myPage" v-if='phoneData.body[0].page=="my"' @click='mypageClick(phoneData.body[0])'>
						<img  src="@/assets/my.png" class="mockimg">
						<img   :src="phoneData.body[0].mybg || 'http://diy.eingdong.com/system_img/mybg.png'" class="bg">
					</div>
					<div class="cartPage" @click='openUrl("false")' v-if='phoneData.body[0].page=="cart"'>
						<img src="@/assets/cart.jpg" style="width: 100%;" alt="">

					</div>
					<div class="severPage" v-if='phoneData.body[0].page=="sever"'>
						<div class="topnav parent-dom" >
							<vue-scroll :ops='vuescroll_ops' @mouseover.native="selectSection($event,'classifyInNavSever')" class='newListNav'>
								<div class="li child-dom" @click='ajaxData.severClassifyon=0' :style='ajaxData.severClassifyon == 0? "border-color:"+appConfig.style+";color:"+appConfig.style:"" ' >全部</div>
								<div class="li child-dom"  @click='ajaxData.severClassifyon=list.id' :style='ajaxData.severClassifyon == list.id? "border-color:"+appConfig.style+";color:"+appConfig.style:"" '  v-for='(list,li) in ajaxData.severClassify' :key='li'>{{list.title}}</div>
							</vue-scroll>
						</div>
						<div class="severcontent " @mouseover="selectSection($event,'severList')" >
							<div class="card-wrapper resizingLi" v-if='ajaxData.severClassifyon==0' @click='openUrl("sever://"+sever.id)' v-for='(sever,si) in ajaxData.severlist' :key="si">
								<div class="showProps">
									<div class="icoli" title='编辑服务' @click.stop='openEdit("服务",sever)'>
										<svg-icon class='icon' icon-class='edit1'/>
									</div>
									<div class="icoli" title='删除服务' @click.stop='openDel("服务",sever)' >
										<svg-icon class='icon' icon-class='del'/>
									</div>
								</div>


								<div class="img">
									<img :src="sever.cover_url | getFirstImg" alt="">
								</div>
								<div class="name">
									{{sever.title}}
								</div>
								<div class="summary">
									{{sever.summary}}
								</div>
								<div class="price">
									<div class="left" v-if='sever.price_type == 0'>
										<p :style="`color:${appConfig.style}`">￥{{sever.sale_price || sever.price }}</p>
										<span v-if='sever.sale_price' >￥{{sever.price}}</span>
									</div>
									<div class="left" v-if='sever.price_type == 1'>
										<p :style="`color:${appConfig.style}`">免费</p>
									</div>
									<div class="left" v-if='sever.price_type == 2'>
										<p :style="`color:${appConfig.style}`">价格面议</p>
									</div>
									<div class="btn" :style="`background:${appConfig.style}`">{{appConfig.severConfig.btn}}</div>
								</div>
							</div>
							<div class="card-wrapper" v-if='ajaxData.severClassifyon==sever.cid' @click='openUrl("sever://"+sever.id)' v-for='(sever,si) in ajaxData.severlist' :key="si">
								<div class="img">
									<img :src="sever.cover_url | getFirstImg" alt="">
								</div>
								<div class="name">
									{{sever.title}}
								</div>
								<div class="summary">
									{{sever.summary}}
								</div>
								<div class="price">
									<div class="left" v-if='sever.price_type == 0'>
										<p :style="`color:${appConfig.style}`">￥{{sever.sale_price || sever.price }}</p>
										<span v-if='sever.sale_price' >￥{{sever.price}}</span>
									</div>
									<div class="left" v-if='sever.price_type == 1'>
										<p :style="`color:${appConfig.style}`">免费</p>
									</div>
									<div class="left" v-if='sever.price_type == 2'>
										<p :style="`color:${appConfig.style}`">价格面议</p>
									</div>
									<div class="btn" :style="`background:${appConfig.style}`">{{appConfig.severConfig.btn}}</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<draggable v-else v-model='phoneData.body' :options='phoneData.phoneOption'  style='height: 100%' ref='phoneDrag' @end='dragEnd' @start='dragStart'>
					<transition-group style='height: 100%;display: block'>
						<div class="section " @mouseover="selectSection($event,'section')" :Style='`margin-bottom:${item.marginBottom}px;${dragIng? "height:50px":""}`' @contextmenu="showMenu(item,index)" :class='phoneData.selectIndex == index?"on":""' @click='selectBox(item,index)' v-for='(item,index) in phoneData.body' :key='index' >
							<div class="titlebox between" v-if=' item.title && item.title.more && !item.title.hidden'>
								<p>{{item.title.name}}</p>
								<div v-if='item.title.more' @click='openUrl(item.title.moreTo)' class='getMore'>
									<span>查看更多</span>
									<svg-icon icon-class='right' />
								</div>
							</div>
							<div class="titlebox" v-else-if='!item.title.hidden'>
								<p>{{item.title.name}}
									<span class="lineL"></span>
									<span class="lineR"></span>
								</p>
							</div>
							<div class="content"  :style="`background: ${item.setbg? item.bgcolor:'#fff'}`">
								<div v-if='item.tagName=="自由容器"' >
									<draggable   v-model='item.freeBox'  :options='phoneData.freeOption'>
										<transition-group  class='freefather' :style='`height: ${item.h}px;z-index:${dragZindex}`'>
										</transition-group>
									</draggable>
									<div class="resizingBox">
										<vue-draggable-resizable  :ref='"resizing_"+i'  class-name-handle="handStyle" :disable-user-select='true' :resizable="true" :parent="false" :snap='true' :lock-aspect-ratio='false' :snapTolerance='4' :z='child.zIndex' @resizing="onResizing($event,child)"  @resizestop='onResizstop($event,child,index,i)' @dragging="onDragging($event,child)"  @dragstop='onDragstop($event,child,index,i)'  :minw='50' :minh='20' :w='child.width' :x='child.left' :y='child.top' :h='child.height' v-for='(child,i) in item.freeBox' :key='child.id' class='resizingLi'>
											<div class="showProps" v-if='child.url' @click='freechildClick(child,index,i)'>
												<div class="icoli" title='跳转到目标链接' @click='openUrl(child.url)'>
													<svg-icon class='icon' icon-class='src'/>
												</div>
											</div>
											<div class="child"  @contextmenu.stop="showMenufree(item,child,i)" :style='`font-size:${child.fontsize}px;color:${child.color};font-style:${child.i};font-weight: ${child.b};text-align:${child.align};`' @click.stop='freechildClick(child,index,i)' @dblclick='editText(child)' @blur="dragBoxBlur(child,'free_'+index+'_'+i)"  v-if='child.tagName=="文本"'>
												<textarea  v-if='child.edit' ref='editbox' v-model='child.content' @blur='editExit(child)' class='editbox'/>
												<span class="edittext" v-else>{{child.content}}</span>
											</div>
											<div class="child "  @contextmenu.stop="showMenufree(item,child,i)" @click.stop='freechildClick(child,index,i)' v-if='child.tagName=="图片"' style="`width: ${child.width};height: ${child.height};`">
												<div class="img imgbox">
													<img :src="child.src || require('@/assets/default_img.jpg')">
												</div>
											</div>
											<div class="child"  @contextmenu.stop="showMenufree(item,child,i)" @click.stop='freechildClick(child,index,i)' v-if='child.tagName=="按钮"' >
												<div  class="freebtn" :style='child.useStyle? "background:"+appConfig.style:"background:"+child.bgcolor' :class='child.styleon'><span :style='`color:${child.color};`'>{{child.label}}</span></div>
											</div>
										</vue-draggable-resizable>
										<div class="changeHeight" @mousedown="changeHeightDown(item,$event)"  ></div>
									</div>
								</div>
								<div class="article"  v-if='item.tagName=="文章列表"' :style='"height: "+item.h+"px"'>
									<div v-if='item.articleValue.length>0'>
										<div class="ul styleA" v-if='item.styleon=="A"'>
											<div v-for='(arcitle,i) in item.articleValue' >
												<div class="list"  v-if='arcitle == sever.id' v-for='(sever,si) in ajaxData.articlelist'>
													<div class="left">
														<p class="title">{{sever.label}}</p>
														<p class="key">{{sever.content | filterHtml}}</p>
														<p class='date'>{{sever.date}}</p>
													</div>
													<img v-if='sever.img' :src="sever.img[0]">
													<div class="sets">
														<div class="btn" @click='openEdit("文章",sever)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" title='打开此模块链接' @click='openUrl("news://"+sever.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="ul styleB" :class='"s"+index' v-if='item.styleon=="B"'>
											<div class="content" style="width: 375px;white-space: nowrap">
												<vue-scroll :ops='vuescroll_ops'>
													<div ref='silder' class="list" v-for='(arcitle,i) in item.articleValue'>
														<div   v-if='arcitle == sever.id' v-for='(sever,si) in ajaxData.articlelist'>
															<div class="img">
																<img v-if='sever.img[0]' :src="sever.img[0]">
															</div>
															<p class="title">{{sever.label}}</p>
															<p class="key">{{sever.content  | filterHtml}}</p>

															<div class="sets">
																<div class="btn" @click='openEdit("文章",sever)'>
																	<svg-icon icon-class='edit1'/>
																</div>
																<div class="btn" @click='openUrl("news://"+sever.id)'>
																	<svg-icon icon-class='src'/>
																</div>
															</div>
														</div>
													</div>
												</vue-scroll>
											</div>
										</div>
										<div class="ul styleC" v-if='item.styleon=="C"' >
											<div  v-for='(arcitle,i) in item.articleValue' style="width: 100%;">
												<div  class="list"  v-if='arcitle == sever.id' v-for='(sever,si) in ajaxData.articlelist'>

													<p class="title">{{sever.label}}</p>
													<div class="bottom">
														<div class="img"  v-for='(img,ii) in sever.img'>
															<img :src="img">
														</div>
													</div>
													<div class="sets">
														<div class="btn" @click='openEdit("文章",sever)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("news://"+sever.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="ul styleD" v-if='item.styleon=="D"'>
											<div v-for='(arcitle,i) in item.articleValue'>
												<div  class="list"  v-if='arcitle == sever.id' v-for='(sever,si) in ajaxData.articlelist'>
													<p class="title">{{sever.label}}</p>
													<p class="key">{{sever.content  | filterHtml}}</p>
													<p class='date'>{{sever.date}}</p>
													<div class="sets">
														<div class="btn" @click='openEdit("文章",sever)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("news://"+sever.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="null"  v-else >
										<div class="top">请从右侧面板中选择文章</div>
										<div class="btns" >
											<el-button size='mini' type='primary' :style='"background:"+appConfig.style'>添加文章</el-button>
											<el-button size='mini' @click='getArticle'>选择文章</el-button>
										</div>
									</div>
								</div>
								<div class="idcard" v-if='item.tagName=="名片"'>
									<div class="ul styleA" v-if='item.styleon=="名片A"'>
										<div v-for='(fitem,fi) in item.cardValue'>
											<div  class="list"  v-if='fitem == citem.id' v-for='(citem,ci) in ajaxData.cardlist'>
												<div class="head">
													<img :src="citem.avatar" alt="">
												</div>
												<div class="info">
													<p class="title">{{citem.name}}</p>
													<p class="key">{{citem.post}}</p>
												</div>
												<div class="phone" @click='openUrl("tel://"+citem.telphone)'>
													<svg-icon icon-class='phone' />
												</div>
												<div class="sets">
													<div class="btn" @click='openEdit("名片",citem)'>
														<svg-icon icon-class='edit1'/>
													</div>
													<div class="btn" @click='openUrl("card://"+citem.id)'>
														<svg-icon icon-class='src'/>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="ul styleB" v-if='item.styleon=="名片B"'>
										<vue-scroll :ops='vuescroll_ops'>
											<div style="display: flex">
												<div v-for='(fitem,fi) in item.cardValue'>
													<div  class="list "  v-if='fitem == citem.id' v-for='(citem,ci) in ajaxData.cardlist'>
														<div class="head">
															<img :src="citem.avatar" alt="">
														</div>
														<div class="info">
															<p class="title">{{citem.name}}</p>
															<p class="key">{{citem.post}}</p>
														</div>
														<div class="sets">
															<div class="btn" @click='openEdit("名片",citem)'>
																<svg-icon icon-class='edit1'/>
															</div>
															<div class="btn" @click='openUrl("card://"+citem.id)'>
																<svg-icon icon-class='src'/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</vue-scroll>
									</div>
									<div class="null" v-if='item.cardValue.length<=0'>
										<div class="top">请从右侧面板中选择名片</div>
										<div class="btns" >
											<el-button size='mini' type='primary' :style='"background:"+appConfig.style'>添加名片</el-button>
											<el-button size='mini' @click='getArticle'>选择名片</el-button>
										</div>
									</div>
								</div>

								<div class="sever"  v-if='item.tagName=="服务"' :style='"height: "+item.h+"px"'>
									<div v-if='item.severValue.length>0'>
										<div class="ul styleA" v-if='item.styleon=="服务A"'>
											<div v-for='(list,i) in ajaxData.severlist' :key='i'>
												<div  v-if='value == list.key'  class="section" v-for='(value,check) in item.severValue'>
													<div class="sets">
														<div class="btn" @click='openEdit("服务",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("sever://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="img"><img :src="list.img[0]"></div>
													<div class="title">{{list.label}}</div>
													<div class="info">{{list.content}}</div>
													<div class="bottom">
														<div class="price" v-if='list.price_type == 0'>
															<p :style="'color: '+appConfig.style">￥{{list.sale_price || list.price}}</p>
															<p class="store" v-if='list.sale_price'>￥{{list.price}}</p>
														</div>
														<div class="price" v-if='list.price_type == 1'>
															<p :style="'color: '+appConfig.style">免费</p>
														</div>
														<div class="price" v-if='list.price_type == 2'>
															<p :style="'color: '+appConfig.style">价格面议</p>
														</div>
														<div class="btn" :style="'background: '+appConfig.style">立即预约</div>
													</div>
												</div>
											</div>
										</div>
										<div class="ul styleB" v-if='item.styleon=="服务B"'>
											<div v-for='(list,i) in ajaxData.severlist' :key='i'>
												<div  v-if='value == list.key' class="section" v-for='(value,check) in item.severValue'>
													<div class="sets">
														<div class="btn" @click='openEdit("服务",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("sever://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="img"><img :src="list.img[0]"></div>
													<div class="right">
														<div class="title">{{list.label}}</div>
														<div class="info">{{list.content}}</div>
														<div class="bottom">
															<div class="price" v-if='list.price_type == 0'>
																<p :style="'color: '+appConfig.style">￥{{list.sale_price || list.price}}</p>
																<p class="store" v-if='list.sale_price'>￥{{list.price}}</p>
															</div>
															<div class="price" v-if='list.price_type == 1'>
																<p :style="'color: '+appConfig.style">免费</p>
															</div>
															<div class="price" v-if='list.price_type == 2'>
																<p :style="'color: '+appConfig.style">价格面议</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="ul styleC" v-if='item.styleon=="服务C"'>
											<div v-for='(list,i) in ajaxData.severlist' :key='i'  class="sections">
												<div v-if='value == list.key' v-for='(value,check) in item.severValue'>
													<div class="sets">
														<div class="btn" @click='openEdit("服务",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("sever://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="img"><img :src="list.img[0]"></div>
													<div class="title">{{list.label}}</div>
													<div class="info">{{list.content}}</div>
													<div class="bottom">
														<div class="price" v-if='list.price_type == 0'>
															<p :style="'color: '+appConfig.style">￥{{list.sale_price || list.price}}</p>
															<p class="store" v-if='list.sale_price'>￥{{list.price}}</p>
														</div>
														<div class="price" v-if='list.price_type == 1'>
															<p :style="'color: '+appConfig.style">免费</p>
														</div>
														<div class="price" v-if='list.price_type == 2'>
															<p :style="'color: '+appConfig.style">价格面议</p>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="null" v-else >
										<div class="top">请从右侧面板中添加服务</div>
										<div class="btns" >
											<el-button size='mini' type='primary' :style='"background:"+appConfig.style'>添加服务</el-button>
											<el-button size='mini' @click='getArticle'>选择服务</el-button>
										</div>
									</div>
								</div>
								<div class="goods"  v-if='item.tagName=="商品"' :style='"height: "+item.h+"px"'>
									<template v-if='item.value.length>0'>
										<div class="ul styleA" v-if='item.styleon=="商品A"'>
											<div v-for='(list,i) in ajaxData.goodsList' :key='i'>
												<div  v-if='value == list.id' class="li" :style="`background:${list.cardBg}`" v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("商品",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images[0]" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{ list.promotional_price>0 ? list.promotional_price:list.price }}
															<span class='price_line' v-if='list.price>0'>{{list.price}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="ul styleB" v-if='item.styleon=="商品B"'>
											<div  class="li" v-for='(list,i) in ajaxData.goodsList' :key='i' >
												<div class="i" v-if='value == list.id'  v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("商品",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images[0]" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{ list.promotional_price>0 ? list.promotional_price:list.price }}
															<span class='price_line' v-if='list.price>0'>{{list.price}}</span>
														</div>
													</div>

												</div>
											</div>
										</div>
										<div class="ul styleC" v-if='item.styleon=="商品C"'>
											<div v-for='(list,i) in ajaxData.goodsList' :key='i'>
												<div  v-if='value == list.id'  class="li" v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("商品",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images[0]" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{ list.promotional_price>0 ? list.promotional_price:list.price }}
															<span class='price_line' v-if='list.price>0'>{{list.price}}</span>
														</div>
													</div>

												</div>
											</div>
										</div>
										<div class="ul styleD" v-if='item.styleon=="商品D"'>
											<div  class="li" v-for='(list,i) in ajaxData.goodsList' :key='i' >
												<div class="i" v-if='value == list.id'  v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("商品",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images[0]" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price"> ￥{{ list.promotional_price>0 ? list.promotional_price : list.price }}
															<span class='price_line' v-if='list.price>0'>{{list.price}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
									<div class="null" v-else >
										<div class="top">请从右侧面板中添加商品</div>
										<div class="btns" >
											<el-button size='mini' type='primary' :style='"background:"+appConfig.style'>添加商品</el-button>
											<el-button size='mini' @click='getArticle'>选择商品</el-button>
										</div>
									</div>
								</div>
								<div class="goods"  v-if='item.tagName=="视频课程"' :style='"height: "+item.h+"px"'>
									<template v-if='item.value.length>0'>
										<div class="ul styleA" v-if='item.styleon=="课程A"'>
											<div v-for='(list,i) in ajaxData.video_list' :key='i'>
												<div  v-if='value == list.id' class="li" :style="`background:${list.cardBg}`" v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("课程",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("video://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{list.price}}</div>
													</div>

												</div>
											</div>
										</div>
										<div class="ul styleB" v-if='item.styleon=="课程B"'>
											<div  class="li" v-for='(list,i) in ajaxData.video_list' :key='i' >
												<div class="i" v-if='value == list.id'  v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("课程",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{list.price}}</div>
													</div>

												</div>
											</div>
										</div>
										<div class="ul styleC" v-if='item.styleon=="课程C"'>
											<div v-for='(list,i) in ajaxData.video_list' :key='i'>
												<div  v-if='value == list.id'  class="li" v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("课程",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{list.price}}</div>
													</div>

												</div>
											</div>
										</div>
										<div class="ul styleD" v-if='item.styleon=="课程D"'>
											<div  class="li" v-for='(list,i) in ajaxData.video_list' :key='i' >
												<div class="i" v-if='value == list.id'  v-for='(value,check) in item.value'>
													<div class="sets">
														<div class="btn" @click='openEdit("课程",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("goods://"+list.id)'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
													<div class="left"><img :src="list.images" alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="price">￥{{list.price}}</div>
													</div>

												</div>
											</div>
										</div>
									</template>
									<div class="null" v-else >
										<div class="top">请从右侧面板中添加课程</div>
										<div class="btns" >
											<el-button size='mini' type='primary' :style='"background:"+appConfig.style'>添加课程</el-button>
											<el-button size='mini' @click='getArticle'>选择课程</el-button>
										</div>
									</div>
								</div>

								<div class="coupon"  v-if='item.tagName=="优惠券"' :style='"height: "+item.h+"px"'>
									<template v-if='item.value.length>0'>
										<div class="ul styleA" v-if='item.styleon=="优惠券A"'>

											<vue-scroll :ops='vuescroll_ops'>
												<div style="display: flex">
													<div v-for='(value,check) in item.value'>
														<div  class="list"  v-if='value == list.id' v-for='(list,i) in ajaxData.couponList'>
															<div class="top">
																<div class="title">{{list.title}}</div>
																<div class="reduction">{{list.reduction}} <span>元</span></div>
															</div>
															<div class="bottom">
																满{{list.full}}可用
															</div>
															<div class="sets">
																<div class="btn" @click='openEdit("优惠券",list)'>
																	<svg-icon icon-class='edit1'/>
																</div>
																<div class="btn" @click='openUrl("123")'>
																	<svg-icon icon-class='src'/>
																</div>
															</div>
														</div>
													</div>
												</div>
											</vue-scroll>

										</div>
										<div class="ul styleB" v-if='item.styleon=="优惠券B"'>
											<div v-for='(list,i) in ajaxData.couponList' :key='i'>
												<div  v-if='value == list.id'  class="li" v-for='(value,check) in item.value'>
													<div class='left'>
														<div class='ttitle'>
															<span>￥</span>{{list.reduction }}
														</div>
														<div class='lr'>
															<div class='full'>{{list.title}}</div>
															<div class='date'>{{list.type==1? list.start_time+"-"+list.end_time : "领取后"+list.expiry+"天内有效"}}</div>
														</div>
													</div>
													<div class='right'>
														<div class='btn' :style='"background:"+appConfig.style' >
															领券
														</div>
													</div>
													<div class="sets">
														<div class="btn" @click='openEdit("优惠券",list)'>
															<svg-icon icon-class='edit1'/>
														</div>
														<div class="btn" @click='openUrl("123")'>
															<svg-icon icon-class='src'/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
									<div class="null" v-else >
										<div class="top">请从右侧面板中添加优惠券</div>
										<div class="btns" >
											<el-button type='primary' size='mini' @click='getArticle'>选择优惠券</el-button>
										</div>
									</div>
								</div>
								<div class="groupby"  v-if='item.tagName=="商品拼团"' :style='"height: "+item.h+"px"'>
									<template v-if='item.value.length>0'>
										<div class="ul styleA" v-if='item.styleon=="拼团A"'>

											<div v-for='(list,i) in ajaxData.groupbyList' :key='i'>
												<div   class="li" :style="`background:${list.cardBg}`" v-for='(value,check) in item.value'>
													<template v-if='value == list.id'>
													<div class="left"><img :src="list.images[0] " alt=""></div>
													<div class="right">
														<div class="title">{{list.title}}</div>
														<div class="right_bottom">
															<div class="price"><span>{{list.people}}人团</span>￥{{list.groupbuy_price}}</div>
															<div class="btn_join">去开团</div>
														</div>
													</div>
													</template>

												</div>
											</div>
										</div>
									</template>
									<div class="null" v-else >
										<div class="top">请从右侧面板中添加拼团</div>
										<div class="btns" >
											<el-button type='primary' size='mini' >选择拼团</el-button>
										</div>
									</div>
								</div>




								<div class="search"  v-if='item.tagName=="搜索"' :style='"height: "+item.h+"px"'>
									<div class="ul styleA" v-if='item.styleon=="搜索A"'>
										<div class="ico">
											<svg-icon icon-class='search'/>
										</div>
										<input type="text" :placeholder="item.placeholder" disabled="">
									</div>
									<div class="ul styleB" v-if='item.styleon=="搜索B"'>
										<div class="ico">
											<svg-icon icon-class='search'/>
										</div>
										<input type="text" :placeholder="item.placeholder" disabled="">
									</div>
									<div class="ul styleC" v-if='item.styleon=="搜索C"'>
										<div class="ico">
											<svg-icon icon-class='search'/>
										</div>
										<input type="text" :placeholder="item.placeholder" disabled="">
									</div>
									<div class="ul styleD" v-if='item.styleon=="搜索D"'>
										<div class="ico">
											<svg-icon icon-class='search'/>
										</div>
										<input type="text" :placeholder="item.placeholder" disabled="">
									</div>
								</div>
								<div  class="news" v-if='item.tagName=="多图文"' :style='"height: "+item.h=="auto"? "auto":item.h+"px"'>
									<div v-if='item.imglist.length>0' :style="`height:${item.swiper_height || 150}px`" >
										<div v-if='item.styleon=="多图文A"' >
										<!-- 	{{item.swiper_height}} -->
											<el-carousel :height='(item.swiper_height?item.swiper_height:150)+"px"' arrow='never'>
												<el-carousel-item v-for="(img,ins) in item.imglist" :key="ins">
													<div class="resizingLi">
														<div class="showProps" v-if='img.url'>
															<div class="icoli" title='跳转到目标链接' @click='openUrl(img.url)'>
																<svg-icon class='icon' icon-class='src'/>
															</div>
														</div>
														<img  :src="img.src" class="banner">
													</div>
												</el-carousel-item>
											</el-carousel>
										</div>
										<div  class="modelb" :class='"s"+index' v-if='item.styleon=="多图文B"'>
											<div class="content" style="width: 375px;white-space: nowrap">
												<vue-scroll :ops='vuescroll_ops'>
													<section class="resizingLi" style="position: relative" v-for="(img,ins) in item.imglist" :key="ins">
														<div class="showProps" v-if='img.url'>
															<div class="icoli" title='跳转到目标链接' @click='openUrl(img.url)'>
																<svg-icon class='icon' icon-class='src'/>
															</div>
														</div>
														<div class="img"><img :src="img.src" class="banner"></div>
														<div class="title">{{img.label}}</div>
													</section>
												</vue-scroll>
											</div>
										</div>
										<div  class="modelc" v-if='item.styleon=="多图文C"'>
											<section @dblclick='openUrl(img.url)' class="resizingLi" style="position: relative"  v-for="(img,ins) in item.imglist" :key="ins">
												<div class="showProps" v-if='img.url'>
													<div class="icoli" title='跳转到目标链接' @click='openUrl(img.url)'>
														<svg-icon class='icon' icon-class='src'/>
													</div>
												</div>
												<div class="img"><img :src="img.src" class="banner"></div>
												<p class="title">{{img.label}}</p>
											</section>
											<section style="height: 0px;"></section>
										</div>
									</div>
									<div class="null"  v-else>
										<div class="top">请从右侧面板中添加图片</div>
										<div class="btns" >
											<el-button size='mini' @click='addImgToNews(item)' type='primary' :style='"background:"+appConfig.style'>添加图片</el-button>
											<el-button size='mini' >选择图片</el-button>
										</div>
									</div>
								</div>
								<div class="video" v-if='item.tagName=="视频"' :style='"height: "+item.h+"px"'>
									<div  class="videobox">
										<video class="videoblock" ref='video' :controls="item.showCtrl" v-if='item.srcfrom=="上传视频"' :src="item.src"></video>
										<video class="videoblock" ref='video' :controls="item.showCtrl" v-else-if='item.srcfrom=="使用腾讯视频"' :src="item.srctxParse "></video>
										<div class="indexImg"  v-if='!item.showCtrl'>
											<img class=""  :src="item.indexImg" />
										</div>
										<div class="play" v-if='!item.showCtrl' @click='playvideo(item)'>
											<div class="icon">
												<svg-icon class='ico' icon-class='play'/>
											</div>
										</div>
									</div>
									<p class="desc">{{item.desc}}</p>
								</div>
								<div class="navs" v-if='item.tagName=="魔方导航"' :style='"height: "+item.h+"px"'>
									<div class="styleA" v-if='item.navstyleOn=="styleA"'>
										<div class='resizingLi li' :class='childon[0]==index && childon[1]==i? "dragon":""' @click.stop='formItemClick(ico,i,index)'    v-for='(ico,i) in item.list' :key='i' :style='item.col==4? "width:25%":"width:20%"'>
											<template v-if='!ico.hidden'>
											<div class="showProps" v-if='ico.url'>
												<div class="icoli" title='跳转到目标链接' @click='openUrl(ico.url)'>
													<svg-icon class='icon' icon-class='src'/>
												</div>
											</div>
											<div class="ico" :style='`background:${ico.bgcolor}`'>
												<svg-icon v-if='ico.icon.type=="图标"' class='icoicon' :style='`color:${ico.icon.color}`' :icon-class='ico.icon.src'/>
												<img v-else :src="ico.icon.src" />
											</div>
											<p :style='`font-weight:${ico.b};color:${ico.color};font-size:${ico.fontsize}px`'>{{ico.label}}</p>
											</template>
										</div>
									</div>
									<div class="styleB" v-if='item.navstyleOn=="styleB"' >
										<div :class='childon[0]==index && childon[1]==i? "dragon":""' @click.stop='formItemClick(ico,i,index)'  class="resizingLi li" v-if='!ico.hidden' v-for='(ico,i) in item.list' :key='i'  :style='`background:${ico.bgcolor}`'>

											<div class="showProps" v-if='ico.url'>
												<div class="icoli" title='跳转到目标链接' @click='openUrl(ico.url)'>
													<svg-icon class='icon' icon-class='src'/>
												</div>
											</div>
											<div class="titles">
												<p :style='`font-weight:${ico.b};color:${ico.color};font-size:${ico.fontsize}px`'>{{ico.label}}</p>
												<p :style='`font-weight:${ico.minTitleB};color:${ico.minTitleColor};font-size:${ico.minTitleFontsize}px`' class="min">{{ico.minTitle}}</p>
											</div>
											<div class="ico">
												<svg-icon v-if='ico.icon.type=="图标"' class='icoicon' :style='`color:${ico.icon.color}`' :icon-class='ico.icon.src'/>
												<img v-else :src="ico.icon.src" />
											</div>
										</div>
										<div style="clear: both;"></div>
									</div>
									<div  class="styleC" v-if='item.navstyleOn=="styleC"'>
										<div class="resizingLi li"  :class='childon[0]==index && childon[1]==i? "dragon":""' @click.stop='formItemClick(ico,i,index)' v-if='!ico.hidden' v-for='(ico,i) in item.list' :key='i'  :style='`background:${ico.bgcolor}`' >
											<div class="showProps" v-if='ico.url'>
												<div class="icoli" title='跳转到目标链接' @click='openUrl(ico.url)'>
													<svg-icon class='icon' icon-class='src'/>
												</div>
											</div>
											<div class="titles">
												<p :style='`font-weight:${ico.b};color:${ico.color};font-size:${ico.fontsize}px`'>{{ico.label}}</p>
												<p :style='`font-weight:${ico.minTitleB};color:${ico.minTitleColor};font-size:${ico.minTitleFontsize}px`' class="min">{{ico.minTitle}}</p>
											</div>
											<div class="ico">
												<svg-icon v-if='ico.icon.type=="图标"' class='icoicon' :style='`color:${ico.icon.color}`' :icon-class='ico.icon.src'/>
												<img v-else :src="ico.icon.src" />
											</div>
										</div>
									</div>
									<div class="styleD" v-if='item.navstyleOn=="styleD"'>
										<div :class='childon[0]==index && childon[1]==i? "dragon":""' @click.stop='formItemClick(ico,i,index)' class="resizingLi li" v-if='!ico.hidden' v-for='(ico,i) in item.list' :key='i'  :style='`background:${ico.bgcolor}`'>
											<div class="showProps" v-if='ico.url'>
												<div class="icoli" title='跳转到目标链接' @click='openUrl(ico.url)'>
													<svg-icon class='icon' icon-class='src'/>
												</div>
											</div>
											<div class="titles" >
												<p :style='`font-weight:${ico.b};color:${ico.color};font-size:${ico.fontsize}px`'>{{ico.label}}</p>
												<p :style='`font-weight:${ico.minTitleB};color:${ico.minTitleColor};font-size:${ico.minTitleFontsize}px`' class="min">{{ico.minTitle}}</p>
											</div>
											<div class="ico">
												<svg-icon v-if='ico.icon.type=="图标"' class='icoicon' :style='`color:${ico.icon.color}`' :icon-class='ico.icon.src'/>
												<img v-else :src="ico.icon.src" />
											</div>
										</div>
									</div>
								</div>

								<div  class="formbox" v-if='item.tagName=="表单"' :style='"height: "+item.h+"px"'>
									<div v-for='(forms,formi) in ajaxData.formsList'  v-if='forms.id == item.formid'>
										<div class="formItem" :class='childon[0]==index && childon[1]==i? "dragon":""' @click.stop='formItemClick(child,i,index)' v-for='(child,i) in forms.configuration'>
											<p class="label" v-if='child.showLabel' :class='child.required? "require":""'>{{child.label}}：</p>
											<div class='child' v-if='child.tagName=="input" || child.tagName=="datebox"'>
												<input type="text" :placeholder="child.placeholder">
											</div>
											<div class='child' v-if='child.tagName=="upload"'>
												<input type="text" :placeholder="child.placeholder">
												<div class="uploadbtn" >点击上传</div>
											</div>
											<div class='child' v-if='child.tagName=="textarea"'>
												<textarea :placeholder="child.placeholder"></textarea>
											</div>
											<div class='' v-if='child.tagName=="radio"'>
												<div class="radiobox">
													<el-radio v-model='child.check' :label='radio.value' :key='radioi' v-for='(radio,radioi) in child.section'></el-radio>
												</div>
											</div>
											<div class='' v-if='child.tagName=="checkbox"'>
												<div class="radiobox">
													<el-checkbox v-model='radio.check' :label='radio.value' :key='radioi' v-for='(radio,radioi) in child.section'></el-checkbox>
												</div>
											</div>
										</div>
										<div class="submitform"  :style='"background:"+appConfig.style'>{{item.submitButton}}</div>
									</div>
									<div class="null" v-if="item.formid==-1">
										<div class="top">请从右侧表单管理选择表单</div>
										<div class="btns" >
											<el-button size='mini' type='primary' @click.stop='addForms' :style='"background:"+appConfig.style'>添加表单</el-button>
											<el-button size='mini' >选择表单</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition-group>
				</draggable>
			</div>
			<div class="footer">
				<div  v-if='appConfig.widget[0].check' style="height: 50px"></div>
				<div class="tarbar" @click='tarbarClick' @mouseover='selectSection($event,"tabbar")' v-if='appConfig.widget[0].check ' :style='`background:${appConfig.widget[0].bg}`'>
					<div class="li" @click.stop='openUrl(item.url)' v-for='(item,index) in appConfig.widget[0].list' :style='`color:${item.url == appConfig.appPage[appConfig.appPageon].url? appConfig.widget[0].useStyle? appConfig.style:appConfig.widget[0].hover:appConfig.widget[0].default}`'>
						<svg-icon class='ico' v-if='item.icon_on.type=="图标" && item.icon_on.src && item.url == appConfig.appPage[appConfig.appPageon].url' :icon-class='item.icon_on.src'/>
						<img class='ico' v-else-if='item.icon_on.type=="图片" && item.icon_on.src && item.url == appConfig.appPage[appConfig.appPageon].url' :src='item.icon_on.src'/>
						<img class='ico' v-else-if='item.icon.type=="图片" && item.icon.src' :src='item.icon.src'/>
						<svg-icon class='ico' v-else-if='item.icon.type=="图标" && item.icon.src'  :icon-class='item.icon.src'/>
						<p>{{item.title}}</p>
					</div>
				</div>
			</div>
			<vue-context-menu :contextMenuData="contextMenuData" @toHome='toHome' @toEnd='toEnd' @delChild='delChild' @toTop='toTop' @toBottom='toBottom' @copyBlock="copyBlock"  @delBlock="delBlock">
			</vue-context-menu>
			<div class="outTools" v-if='showOutTools' :style='`top:${outToolsTop}px;display:${showOutTools?"flex":"none"}`'>
				<div class="tools" v-if='showOutTools == "tabbar"' @click='tarbarClick'>
					<svg-icon icon-class='edit1' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNav"' @click='editClassify("article")' >
					<svg-icon icon-class='edit1' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNav"' @click='addClassify("article")' >
					<svg-icon icon-class='add' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNavSever"' @click='editClassify("sever")' >
					<svg-icon icon-class='edit1' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNavSever"' @click='addClassify("sever")' >
					<svg-icon icon-class='add' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNavGoods"' @click='editClassify("goods")' >
					<svg-icon icon-class='edit1' />
				</div>
				<div class="tools" v-if='showOutTools == "classifyInNavGoods"' @click='addClassify("goods")' >
					<svg-icon icon-class='add' />
				</div>
				<div class="tools" v-if='showOutTools == "atricleList"' @click='openEdit("文章","add")' >
					<svg-icon icon-class='add' />
				</div>
				<div class="tools" v-if='showOutTools == "severList"' @click='openEdit("服务","add")' >
					<svg-icon icon-class='add' />
				</div>
				<div class="tools" v-if='showOutTools == "cardList"' @click='openEdit("名片","add")' >
					<svg-icon icon-class='add' />
				</div>
			</div>
		</div>

		<div class="menus">
			<div class="icon" :class='history.length<1 || hisOn==0? "Cant":""'  @click='historyBack'>
				<svg-icon icon-class='toL' />
			</div>
			<div class="icon" :class='history.length-1 <= hisOn? "Cant":""' @click='historyGo'>
				<svg-icon icon-class='toR' />
			</div>
		</div>

	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import Sortable  from 'sortablejs'
	import VueDraggableResizable from '../../../static/vue-draggable-resizable.js'
	// import VueDraggableResizable from '../../../static/vue-draggable-resizable-gorkys.js'
	import "../../../static/VueDraggableResizable.css"
	import {parseUrl} from '@/utils/index'
	import {getArticleList,getSeverList,get_classify_list,getCardList,get_sever_classify_list,addForms,add_classify,add_sever_classify,delArticle,delSever,delCard,getClassifyList,addGoodsClassify,editGoodsClassify,getGoodsList,getTicketList,get_groupBuy_list,get_course_list_all} from "@/api/api"


	var p,lb,rb,pb,tb,_this,dialogs;
	export default{
		components:{
			draggable,
			Sortable,VueDraggableResizable,
		},
		name:'pb',
		data(){
			return{
				goodsClassnavon:0,
				goodsClassnavonChild:0,
				dragIng:false,
				vuescroll_ops:{
					mode:"slide",
					sizeStrategy: 'percent',
					detectResize:false,
					scrollPanel:{
						scrollingY:false
					},
					rail:{
						size:"0px"
					}
				},

				vueSwiper_ops:{
					scrollPanel: {
						scrollingY: false
					},
					paging:true
				},
				videoPlay:false,
				wrapperWidth:210,
				newsBwidth:120,
				rightBtnSelect:-1,
				dragZindex:0,
				contextMenuData: {
					menuName: 'father',
					axis: {
						x: null,
						y: null
					},
					menulists: [
					{
						fnHandler: 'copyBlock',
						btnName: '复制模块'
					},
					{
						fnHandler: 'delBlock',
						btnName: '删除模块'
					}
					]
				},
				infoNav:'联系我',
				modKey:false,
				childon:[-1,-1],
				showOutTools:false,
				outToolsTop:0,
				lock_aspect:true
			}
		},
		filters:{
			filterHtml(val){
				return val.replace(/<[^>]+>/g,"")
			},
			getFirstImg(val){
				if(typeof(val)== "string"){
					return val.split(",")[0]
				}
				else{
					return val[0]
				}
			},
		},
		computed:{
			goodsClassifyStore(){
				return this.$store.state.goodsClassifyStore
			}
		},
		props:{
			phoneData:{
				type:Object
			},
			rightData:{
				type:Object
			},
			appConfig:{
				type:Object
			},
			ajaxData:{
				type:Object
			},
			history:{
				type:Array
			},
			hisOn:{
				type:Number
			}
		},
		watch:{
			rightData:{
				handler(value){
					if(value.tagName == "文章列表"){
						this.getArticleList()
					}
					if(value.tagName =="服务"){
						this.getSeverList()
					}
					if(value.tagName =="名片"){
						this.getCardList()
					}
					if(value.tagName =="优惠券"){
						this.getTicketList()
					}
					if(value.tagName =="商品拼团"){
						this.get_groupBuy_list()
					}
				},
				deep:true
			},
		},
		mounted(){
			p = this.$parent;
			_this=this;
			dialogs = window.$dialog;
			rb = this.$parent.$refs.rightBlock || console.log('phone -> rb模块不存在');
			tb = this.$root.$children[0].$children[1].$children[1] || console.log('phone -> tb模块不存在');
			this.getArticleList()
			this.getarticleClassify()
			this.getSeverClassify()
			this.getGoodsClassify()
			this.getCardList()
			this.getSeverList()
			this.getGoodsList()
			this.getTicketList()
			this.get_groupBuy_list()
			this.get_course_list_all();
      console.log(this.ajaxData)
		},
		methods:{
			mypageClick(item){
				this.$set(p,'rightData',item)
			},
			changeHeightDown(item,e){
				console.log("鼠标按下")
				this.changeH = true;
				var startX=Math.abs(e.clientX);
				var startY=Math.abs(e.clientY);
				var startH=item.h;
				document.onmouseup=e=>{

					console.log("鼠标离开")
					document.onmousemove = null
					this.changeH = false;
				}
				document.onmousemove=e=>{
					var distX=Math.abs(e.clientX);
					var distY=Math.abs(e.clientY);
					item.h = parseInt(startH) +Math.floor(parseInt(distY-startY));
				}
			},
			editClassify(where){
				switch(where){
					case "article":
					this.$set(p,'rightData',{tagName:'文章分类',nav:['编辑分类'],navOn:0});
					break;
					case "sever":
					this.$set(p,'rightData',{tagName:'服务分类',nav:['编辑分类'],navOn:0});
					break;
					case "goods":
					this.$set(p,'rightData',{tagName:'商品分类',nav:['编辑分类'],navOn:0});
					break;
				}
			},
			addClassify(where){
				this.$prompt('分类名称', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					switch(where){
						case "article":
						add_classify({title:value},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getarticleClassify()
						})
						break;
						case "sever":
						add_sever_classify({title:value},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getSeverClassify()
						})
						break;
						case "goods":
						addGoodsClassify({title:value},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getGoodsClassify()
						})
						break;
					}
				}).catch(() => { });
			},
			headClick(){
				if(!p.appConfig.navigationBar){
					this.$set(p.appConfig,'navigationBar',{tagName:'导航栏',nav:['导航栏'],navOn:0,bgColor:"#ffffff",userBg:'#ffffff',frontColor:"#000000"})
				}
				this.$set(p,"rightData",p.appConfig.navigationBar)
			},
			goodsclassifyClick(item){
				this.$set(p,'rightData',item[0])
				console.log(item)
			},
			selectSection(e,where){
				if(where == "classifyInNav"){
					this.outToolsTop = 68;
				}
				else if(where == "classifyInNavSever"){
					this.outToolsTop = 68;
				}
				else if(where == "classifyInNavGoods"){
					this.outToolsTop = 68;
				}
				else if(where == "atricleList"){
					this.outToolsTop = 127;
				}
				else if(where == "severList"){
					this.outToolsTop = 127;
				}
				else if(where == "cardList"){
					this.outToolsTop = 92;
				}
				else{
					this.outToolsTop = e.currentTarget.offsetTop - document.getElementById("body").scrollTop ;
				}
				this.showOutTools = where;  //[tabbar,section,classifyInNav,classifyInNavSever];
			},
			selectSectionUp(e,item){
				if(e.target.id == "phonebox" || e.target.id == "body"){
					setTimeout(()=>{
						this.outToolsTop = 0;
						this.showOutTools = false;
					},100)
				}
			},
			openDel(type,item){
				this.$confirm('确认删除此内容?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					switch(type){
						case "文章":
						delArticle({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getArticleList()
						})
						break;
						case "服务":
						delSever({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getSeverList()
						})

						break;
						case "名片":
						delCard({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getCardList()
						})
						case "商品":
						delGoods({id:item.id},this,res=>{
							this.$message({
								type:'success',
								message:res.data.msg
							})
							this.getGoodsList()
						})

						break;
					}
				}).catch(() => {});

			},
			openEdit(type,item){
				switch(type){
					case "文章":
					if(item== "add"){
						dialogs.editArticle("add",res=>{
							_this.getArticleList()
						})
					}
					else{
						dialogs.editArticle(item.id,res=>{
							_this.getArticleList()
						})
					}
					break;
					case "服务":
					if(item== "add"){

					}
					else{
						dialogs.editSever(item,res=>{
							_this.getSeverList()
						})
					}
					break;
					case "名片":
					if(item== "add"){
						dialogs.editCard("add",res=>{
							_this.getCardList()
						})
					}
					else{
						dialogs.editCard(item,res=>{
							_this.getCardList()
						})
					}
					break;
					case "优惠券":
					if(item== "add"){
						dialogs.editCoupon('add',res=>{
							pb.getTicketList();
						})
					}
					else{
						dialogs.editCoupon(item,res=>{
							_this.getTicketList()
						})
					}
					break;
					case "商品":
					if(item== "add"){
						dialogs.editGoods('add',res=>{
							pb.getTicketList();
						})
					}
					else{
						dialogs.editGoods(item,res=>{
							_this.getTicketList()
						})
					}
					break;
				}
			},
			pageToEnd(){
				var body = document.getElementById('body');
				setTimeout(()=>{
					body.scrollTop = body.scrollHeight;
				},50)
			},
			freeKeydown(e){
			},
			addForms(){
				this.$prompt('请输入唯一的表单名称', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({ value }) => {
					addForms({name:value},this,res=>{
						this.$message({
							type:'success',
							message:res.data.msg
						})
						this.$set(this.rightData,"formid",res.data.id)
						rb.getForms();
					})
				}).catch(() => {
				});
			},
			pageDClick(type){
				switch(type){
					case "news":
					this.$set(p,'rightData',p.appConfig.newsConfig)
					break
					case "sever":
					this.$set(p,'rightData',p.appConfig.severConfig)
					break
					case "my":
					this.$set(p,'rightData',p.appConfig.myConfig)
					break
					case "card":
					this.$set(p,'rightData',p.appConfig.cardConfig)
					break
				}
			},
			clearNews(){
				this.$set(this.phoneData,'news',{})
				this.$set(this.phoneData,'sever',{})
				this.$set(this.phoneData,'card',{})
				setTimeout(()=>{
					p.rightData={}
				},50)
			},
			getarticleClassify(){
				get_classify_list(this,res=>{
					_this.$set(p.ajaxData,'articleClassify',res.data.list)
				})
			},
			getSeverClassify(){
				get_sever_classify_list(this,res=>{
					_this.$set(p.ajaxData,'severClassify',res.data.list)
				})
			},
			getGoodsClassify(){
				getClassifyList(this,res=>{
					_this.$set(p.ajaxData,'goodsClassify',res.data.list)
				})
			},
			getArticleList(){
				getArticleList({page:1,pagesize:1000},_this,res=>{
					res.data.list.forEach((val,index)=>{
						val.label = val.title;
						val.key=val.id;
						val.classify = val.classify_id;
						val.img = [val.cover_url];
						val.date = val.release_time;
					})
					_this.$set(p.ajaxData,'articlelist',res.data.list)
					_this.$set(p.ajaxData,'siteUrl',res.data.img_site_url)
				})
			},
			getSeverList(){
				getSeverList({page:1,pagesize:1000},_this,res=>{

					res.data.list.forEach((val,index)=>{
						val.label =val.title;
						val.key = val.id;
						val.content = val.summary;
						val.detail = val.details;
						val. date = val.add_time;
						val.img = val.cover_url.split(',');
					})
					_this.$set(p.ajaxData,'severlist',res.data.list)
				})
			},
			getGoodsList(){
				getGoodsList({page:1,pagesize:1000},_this,res=>{
					res.data.list.forEach((val,index)=>{
						val.label =val.title;
						val.key = val.id;
						val.images = val.images.split(',');
					})
          // res.data.list.reverse()
					_this.$set(p.ajaxData,'goodsList',res.data.list)
				})
			},
			get_course_list_all(){
				get_course_list_all({page:1,pagesize:1000},_this,res=>{

					_this.$set(p.ajaxData,'video_list',res.data.list)
				})
			},
			getCardList(){
				getCardList(this,res=>{
					res.data.list.forEach((val,index)=>{
						val.label =val.name;
						val.key = val.id;
					})
					_this.$set(p.ajaxData,'cardlist',res.data.list)
				})
			},
			getTicketList(){
				getTicketList({pagesize:1000},this,res=>{
					res.data.list.forEach((val,index)=>{
						val.label =val.name;
						val.key = val.id;
					})
					_this.$set(p.ajaxData,'couponList',res.data.list)
				})
			},
			get_groupBuy_list(){
				get_groupBuy_list({pagesize:1000},this,res=>{
					res.data.list.forEach((val,index)=>{
						val.images = val.images.split(',');
					})
					_this.$set(p.ajaxData,'groupbyList',res.data.list)
				})
			},
			freeChildKey(e){
			},
			freechildClick(child,index,i){
				this.$set(this,'childon', [index,i])
				p.rightData = child;
			},
			editText(child){
				this.$set(child,'edit',true)
				setTimeout(()=>{
					this.$refs.editbox[0].focus()
				},10)
			},
			editExit(child){
				this.$set(child,'edit',false)
			},
			onResizing(e,child){
				this.canResize = true;
			},
			onResizstop(e,child){
				if(this.canResize){
					this.$set(child,'width',e.width);
					this.$set(child,'height',e.height);
					this.$set(child,'left',e.left);
					this.$set(child,'top',e.top);
					this.canResize = false;
				}
			},
			onDragging(e,child){
				this.canResize = true;
			},
			onDragstop(e,child){
				if(this.canResize){
					this.$set(child,'left',e.left);
					this.$set(child,'top',e.top);
					this.canResize = false;
				}
			},
			playvideo(item){
				this.$refs.video[0].play()
				item.showCtrl = true;
			},
			tarbarClick(){
				p.rightData=p.appConfig.widget[0];
			},
			dragStart(e){
				this.dragIng = true;
			},
			dragEnd(e){
				this.dragIng = false;
			},
			modUp(e,child){
				this.modKey = false;
				if(this.modX){

				}
			},
			formItemClick(child,i,index){
				this.childon = [index,i];
				p.rightData = child;
			},
			dragBoxBlur(child,id){

			},
			historyBack(){
				this.$emit('historyBack');return false;
			},
			historyGo(){
				this.$emit('historyGo');return false;
			},
			showMenu (item,index) {
				this.rightBtnSelect=index;
				event.preventDefault()
				var x = event.clientX
				var y = event.clientY
				this.$set(this.contextMenuData,'menulists',[
				{
					fnHandler: 'copyBlock',
					btnName: '复制模块'
				},
				{
					fnHandler: 'delBlock',
					btnName: '删除模块'
				}
				])
				this.contextMenuData.axis = {
					x, y
				}
			},
			showMenufree (item,child,i) {
				this.rightbtnFather=item;
				this.rightbtnChild=child;
				this.rightBtnSelect=i;
				event.preventDefault();
				var x = event.clientX;
				var y = event.clientY;
				this.$set(this.contextMenuData,'menulists',[
				{
					fnHandler: 'toHome',
					btnName: '置于顶层'
				},
				{
					fnHandler: 'toTop',
					btnName: '上移一层'
				},
				{
					fnHandler: 'toBottom',
					btnName: '下移一层'
				},
				{
					fnHandler: 'toEnd',
					btnName: '置于底层'
				},
				{
					fnHandler: 'delChild',
					btnName: '删除模块'
				},

				])
				this.contextMenuData.axis = {
					x, y
				}

			},
			toHome(){
				var broder = this.rightbtnFather.freeBox;
				var arrNum = [];
				broder.forEach((val,index)=>{
					arrNum.push(val.zIndex)
				})
				var n = eval("Math.max(" + arrNum.toString() + ")");
				this.$set(this.rightbtnChild,'zIndex',n+1)
			},
			toEnd(){
				var broder = this.rightbtnFather.freeBox;
				var arrNum = [];
				broder.forEach((val,index)=>{
					arrNum.push(val.zIndex)
				})
				var n = eval("Math.min(" + arrNum.toString() + ")");
				this.$set(this.rightbtnChild,'zIndex',n-1)

			},
			toTop(){
				var broder = this.rightbtnFather.freeBox;
				var me = this.rightbtnChild.zIndex;
				var arrNum=[];
				broder.forEach((val,index)=>{
					arrNum.push(val.zIndex)
				})
				var bro = me;
				arrNum.forEach((item)=>{
					if(item>me && item<bro){
						bro = item;
					}
				})
				this.$set(this.rightbtnChild,'zIndex',bro+1)
			},
			toBottom(){
				var broder = this.rightbtnFather.freeBox;
				var me = this.rightbtnChild.zIndex;
				var arrNum=[];
				broder.forEach((val,index)=>{
					arrNum.push(val.zIndex)
				})
				var bro = me;
				arrNum.forEach((item)=>{
					if(item<me && item>bro){
						bro = item;
					}
				})
				this.$set(this.rightbtnChild,'zIndex',bro-1)
			},
			addImgToNews(item){
				dialogs.addCover("fn",res=>{
					var imglist = [];
					res.imgcheck.forEach(pic=>{
						imglist.push({label:pic.url,src:res.site+pic.url,url:''})
					})
					this.$set(item,'imglist',imglist)
				})
			},
			delChild(){
				this.rightbtnFather.freeBox.splice(this.rightBtnSelect,1)
			},
			copyBlock () {
				var jsondata = JSON.parse(JSON.stringify(p.phoneData.body[this.rightBtnSelect]));
				p.phoneData.body.splice(this.rightBtnSelect,0,jsondata)
			},
			delBlock () {
				p.phoneData.body.splice(this.rightBtnSelect,1)
			},
			openUrl(url,item){
				this.$emit('openUrl',url,item)
			},
			selectBox(item,index){
				p.phoneData.selectIndex=index;
				this.childon=[-1,-1]
				p.rightData = item;
			},
			mouseUp(e){
				this.$emit('mouseUp',e)
			},
			mousemove(e){
				this.$emit('mousemoves',e);
			},
			bgClick(e){
				if(e.target.id=='phonebox' ){
					p.rightData={}
				}
			},
			getArticle(){
				this.$parent.hideright = false;
			},
		},
		created() {
			let arr = [];
			let _this = this;

			document.addEventListener('keydown',event=>{
				console.log(event.keyCode)
				if(_this.rightData.tagName == "按钮" || _this.rightData.tagName == "文本" || _this.rightData.tagName == "图片"){
					if (event.keyCode === 37) { //left
						_this.$set(_this.rightData,"left",_this.rightData.left-1)
						event.preventDefault();
						event.returnValue = false;
						return false;
					}
					else if(event.keyCode === 38){ //top
						event.preventDefault();
						_this.$set(_this.rightData,"top",_this.rightData.top-1)
						event.returnValue=false;
						return false;
					}
					else if(event.keyCode === 39){//right
						event.preventDefault();
						_this.$set(_this.rightData,"left",_this.rightData.left+1)
						event.returnValue=false;
						return false;
					}
					else if(event.keyCode === 40){//down
						event.preventDefault();
						_this.$set(_this.rightData,"top",_this.rightData.top+1)
						event.returnValue=false;
						return false;
					}
					else if(event.keyCode === 46){ //del
						console.log(this.phoneData.body[this.childon[0]].freeBox[this.childon[1]])
						this.phoneData.body[this.childon[0]].freeBox.splice(this.childon[1],1)
						event.preventDefault();
						event.returnValue=false;
						return false;
					}
				}
				if(event.keyCode === 83 && event.ctrlKey){ //ctrl + s
					event.preventDefault();
					event.returnValue = false;
					tb.saveApp()
					return false;
				}
				if(event.keyCode === 90 && event.ctrlKey){ //ctrl + z
					event.preventDefault();
					event.returnValue = false;
					p.historyBack()
					return false;
				}
				if(event.keyCode === 89 && event.ctrlKey){ //ctrl + y
					event.preventDefault();
					event.returnValue = false;
					p.historyGo()
					return false;
				}
				if(event.keyCode === 192 && event.ctrlKey){ //ctrl + `
					event.preventDefault();
					event.returnValue = false;
					console.log(window.$tb)
					window.$tb.showConsole=!window.$tb.showConsole;
					return false;
				}
				if(event.keyCode === 27){ //esc
					event.preventDefault();
					event.returnValue = false;
					tb.showConsole=false;
					return false;
				}
			})

			// return false
			// document.onkeydown = e=> {
			// 	if(e.srcElement.nodeName !== "INPUT"){
			// 		if(_this.rightData.tagName == "按钮" || _this.rightData.tagName == "文本" || _this.rightData.tagName == "图片"){
			// 			if(e.key.toLowerCase() == 'arrowleft'){
			// 				_this.$set(_this.rightData,"left",_this.rightData.left-1)
			// 				event.returnValue=false;
			// 			}
			// 			if(e.key.toLowerCase() == 'arrowright'){
			// 				_this.$set(_this.rightData,"left",_this.rightData.left+1)
			// 				event.returnValue=false;
			// 			}
			// 			if(e.key.toLowerCase() == 'arrowup'){
			// 				_this.$set(_this.rightData,"top",_this.rightData.top-1)
			// 				event.returnValue=false;
			// 			}
			// 			if(e.key.toLowerCase() == 'arrowdown'){
			// 				_this.$set(_this.rightData,"top",_this.rightData.top+1)
			// 				event.returnValue=false;
			// 			}
			// 			if(e.key.toLowerCase() == 'delete'){
			// 				console.log("childon",this.childon)
			// 				_this.delChild()
			// 				event.returnValue=false;
			// 			}
			// 		}
			// 		else if(arr.length > 0) {
			// 			if(arr.indexOf(e.key.toLowerCase()) >= 0) {
			// 				return
			// 			}
			// 		}
			// 		arr.push(e.key.toLowerCase())
			// 		this.keydown = arr.join('+');
			// 		console.log(this.keydown)
			// 		if(this.keydown == "control+`"){
			// 			tb.showConsole=!tb.showConsole;
			// 			event.returnValue=false;
			// 		}
			// 		if(this.keydown == "escape"){
			// 			tb.showConsole=false;
			// 			event.returnValue=false;
			// 		}
			// 		if(this.keydown == "control+s"){
			// 			tb.saveApp()
			// 			event.returnValue=false;
			// 		}
			// 		if(this.keydown == "control+z"){
			// 			p.historyBack()
			// 		}
			// 		if(this.keydown == "control+y"){
			// 			p.historyGo()
			// 		}

			// 	}
			// }
			// document.onkeyup = function (e) {
			// 	arr.splice(arr.indexOf( e.key.toLowerCase() ),1);
			// 	this.keydown = arr.join('+');
			// }
			// this.keydown = '';
		}
	}
</script>

<style>
.resizingBox{
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	position: absolute;
	display: flex;
	flex-direction: row-reverse
}
</style>



// WEBPACK FOOTER //
// src/components/phone/phone.vue